var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"py-10 py-md-13 py-lg-16"},[_c(_vm.component,{tag:"component"},[(_vm.title)?_c('TitleWidget',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.loading)?_c('LoadingWidget'):[_vm._t("default")]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }